export class ComponentRoute {
  constructor(path, name) {
    this.path = path
    this.name = name
  }
}
